import { MaintenanceVehicle } from "./maintenance-vehicle.model";

export interface MaintenanceScheduleModel {
  vehicleYear: string;
  vehicles: MaintenanceVehicle[];
}